import React, { useState, useEffect } from 'react';
import { MapPin, Calendar, ArrowRight, Star, Globe, Search, ChevronLeft, ChevronRight } from 'lucide-react';
import { getDaysBetweenDatesUTC, getRandomHexColor, ellipsify } from '../../../../../helpers/general';

const Type5TrendsHomePage = (props) => {

    const { 
      setSelectedItinerary,
      highlightedItineraries,
      pageTheme,
      PAGI_LIMIT,
      totalItems,
      setpagiCurrentPage,
      pagiCurrentPage,
    } = props;

    const {
      packageTrendsPageBackground,
      packageTrendsPageCardBackground,
      packageTrendsPagePrimaryColor,
      packageTrendsPageSecondColor,
      packageTrendsPageThirdColor,
      packageTrendsPageFourthColor,
    } = pageTheme;

    const [HERO_ITEMS, SET_HERO_ITEMS] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        SET_HERO_ITEMS(highlightedItineraries);
        if(highlightedItineraries?.length>0){
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % highlightedItineraries.length);
        }, 6000);
        return () => clearInterval(timer);
        }
    }, [ highlightedItineraries ]);

    const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % HERO_ITEMS.length);
    const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + HERO_ITEMS.length) % HERO_ITEMS.length);

    const styles = {
      inputWrapper: {
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          padding: '0.75rem 1rem',
          backgroundColor: 'white',
          borderRadius: '0.85rem',
          border: '1px solid #e2e8f0',
          transition: 'all 0.2s ease',
        }
    };

    const all_pages = [1];
    let i=1;
    while(true){
        i+=PAGI_LIMIT;
        if(i>=totalItems){
            break
        }
        all_pages.push(i);
    }

     return (
      <div style={{position: "relative"}} className="min-h-screen bg-[#FDFCFB]">
        {/* Hero Section */}
        <section style={{/*display: "none"*/}} className="relative h-[70vh] flex items-center justify-center overflow-hidden bg-gray-900">
          <img
            src={HERO_ITEMS[currentSlide]?.image || "https://images.unsplash.com/photo-1523059623039-a9ed027e7fad?auto=format&fit=crop&q=80&w=1920"}
            alt={HERO_ITEMS[currentSlide]?.purpose || "Trending Itineraries"}
            className="absolute inset-0 w-full h-full object-cover -opacity-60"
            referrerPolicy="no-referrer"
          />
          <div className="absolute inset-0 bg-linear-to-b from-black/40 via-transparent to-black/60" />
          
          <div className="relative z-10 text-center px-6 max-w-4xl">
            <div className='border border-white/20 backdrop-blur' style={{backgroundColor: "rgba(0,0,0,0.7)", padding: 20}}>
              {/*<span style={{backgroundColor: packageTrendsPagePrimaryColor, color: packageTrendsPageSecondColor}}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="inline-block px-4 py-1.5 -rounded-full bg-orange-500 text-white text-xs font-bold uppercase tracking-widest mb-6"
              >
                Recently Highlighted
              </span>*/}
              <h1 style={{color: packageTrendsPageSecondColor}}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
                className="text-2xl md:text-3xl font-bold text-white mb-6 -font-serif tracking-tight"
              >
                {HERO_ITEMS[currentSlide]?.purpose || "Trending Itineraries"} <br /> <span>
                  {
                    HERO_ITEMS[currentSlide]?.destination &&
                    <i style={{marginRight: 10, color: packageTrendsPagePrimaryColor}} className="fa-solid fa-map-marker-alt"></i>
                  }
                  {HERO_ITEMS[currentSlide]?.destination}</span>
              </h1>
              {/*<p style={{color: (packageTrendsPageSecondColor+"E6")}}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="text-xl text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed"
              >
                {
                  ellipsify((HERO_ITEMS[currentSlide]?.description || ""), 120) ||
                  "Hand-picked itineraries designed by experts to take you beyond the guidebook and into the heart of the world's most incredible places."
                }
              </p>*/}
              {
                highlightedItineraries?.[0] &&
                <button onClick={()=>setSelectedItinerary(HERO_ITEMS[currentSlide])}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                  //onClick={() => document.getElementById('itineraries')?.scrollIntoView({ behavior: 'smooth' })}
                  className={"bg-white text-["+packageTrendsPageThirdColor+"] px-8 py-4 -rounded-full font-bold hover:bg-["+packageTrendsPagePrimaryColor+"] hover:text-["+packageTrendsPageSecondColor+"] transition-all shadow-xl flex items-center gap-2 mx-auto"}
                >
                  View Itinerary
                  <ArrowRight className="w-5 h-5" />
                </button>
              }
            </div>
          </div>
          <div className="absolute bottom-20 left-0 right-0 z-40 flex items-center justify-center gap-12">
            <div className="flex gap-4">
              {HERO_ITEMS.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`h-1.5 rounded-full transition-all duration-500 ${
                    index === currentSlide ? "w-12 bg-["+packageTrendsPagePrimaryColor+"] shadow-lg shadow-["+packageTrendsPagePrimaryColor+"] -500/50" : "w-3 bg-white/30 hover:bg-white/50"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>

          <button
            onClick={prevSlide}
            className="absolute left-8 top-1/2 -translate-y-1/2 z-40 p-4 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-white hover:bg-white/20 transition-all hidden lg:flex active:scale-90"
            aria-label="Previous slide"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-8 top-1/2 -translate-y-1/2 z-40 p-4 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-white hover:bg-white/20 transition-all hidden lg:flex active:scale-90"
            aria-label="Next slide"
          >
            <ChevronRight className="w-6 h-6" />
          </button>
        </section>

        {/* Itineraries Grid */}
        <section id="itineraries" className="max-w-7xl mx-auto px-6 py-24 -py-2">
          <div style={{/*display: "none"*/}} className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
            <div>
              <h2 style={{color: packageTrendsPageThirdColor}}
                className="text-4xl font-bold text-gray-900 -font-serif mb-4">Trending This Season</h2>
              <p style={{color: (packageTrendsPageThirdColor+"80")}}
                className="text-gray-500 max-w-lg">
                The most loved trips by our community, refreshed every week with exclusive experiences
              </p>
            </div>
            <div style={{color: packageTrendsPagePrimaryColor, display: "none"}}
              className="flex items-center gap-4 text-sm font-bold uppercase tracking-widest text-orange-600">
              <span>View All Tours</span>
              <ArrowRight className="w-4 h-4" />
            </div>
          </div>

          <div style={{/*padding: "0 10px", */paddingBottom: 20, display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              {/*<div>
                  <p style={{color: "grey", fontSize: 12}}>
                      <span style={{color: "blue", margin: 5, fontSize: 13}}>{totalItems}</span> 
                      item(s) found
                  </p>
              </div>*/}
              <div style={styles.inputWrapper} className="hover:border-indigo-200 hover:bg-white focus-within:border-indigo-400 focus-within:bg-white">
                  <Search style={{ width: "24px", height: "24px" }} className="text-slate-400" />
                  <input id="__"
                      type="text"
                      placeholder="Enter City, Country, or Title"
                      className="bg-transparent -border-none -outline-none text-sm -font-bold text-slate-900 w-full"
                  />
              </div>
              <div>
                  <select onInput={e=>setpagiCurrentPage(e.target.value)}
                      value={pagiCurrentPage}
                      style={{/*backgroundColor: pageTheme?.actionButtonsBg, color: pageTheme?.actionButtonsTxtColor,*/ background: "none", color: "black"}}
                      className="select-input-paginator"
                  >
                      {
                          all_pages?.map((each, i)=>{
                              return <option style={{backgroundColor: pageTheme?.actionButtonsBg, color: pageTheme?.actionButtonsTxtColor}}
                                  value={each}
                              >{each} - {(each+PAGI_LIMIT)}</option>
                                  
                          })  
                      }
                  </select>
              </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
            {highlightedItineraries.map((itinerary, index) => (
              <div
                key={itinerary._id.$oid}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                onClick={() =>setSelectedItinerary(itinerary)}
                className="group cursor-pointer bg-white -rounded-3xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-2xl transition-all duration-500 flex flex-col h-full"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={itinerary.image}
                    alt={itinerary.purpose}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    referrerPolicy="no-referrer"
                  />
                  <div className="absolute top-4 left-4">
                    <span style={{color: packageTrendsPageThirdColor}}
                      className="px-3 py-1 -rounded-full bg-white/90 backdrop-blur-md text-gray-900 text-[10px] font-bold uppercase tracking-widest shadow-sm">
                      {itinerary.short_tag || "No Tag"}
                    </span>
                  </div>
                  <div className="absolute bottom-4 right-4">
                    <div style={{backgroundColor: packageTrendsPagePrimaryColor, color: packageTrendsPageSecondColor}}
                      className="px-3 py-1 -rounded-full bg-orange-500 text-white text-sm font-bold shadow-lg">
                      {itinerary.price.toLocaleString()} {itinerary.price_currency.toUpperCase()}
                    </div>
                  </div>
                </div>

                <div className="p-8 flex flex-col flex-grow">
                  <div style={{color: packageTrendsPagePrimaryColor}}
                    className="flex items-center gap-2 text-orange-500 text-xs font-bold uppercase tracking-widest mb-3">
                    <MapPin className="w-3.5 h-3.5" />
                    {itinerary.destination}
                  </div>
                  <h3 style={{color: packageTrendsPageThirdColor}} 
                    className="text-2xl font-bold text-gray-900 mb-4 -font-serif group-hover:text-orange-600 transition-colors">
                    {itinerary.purpose}
                  </h3>
                  <p style={{color: (packageTrendsPageThirdColor+"80")}}
                    className="text-gray-500 text-sm leading-relaxed mb-6 flex-grow line-clamp-3">
                    {itinerary.description}
                  </p>
                  
                  <div className="pt-6 border-t border-gray-50 flex items-center justify-between">
                    <div className="flex items-center gap-1.5">
                      <Calendar className="w-4 h-4 text-gray-400" />
                      <span className="text-xs font-medium text-gray-500">
                        {new Date(itinerary.start_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - {new Date(itinerary.end_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                      </span>
                    </div>
                    <div style={{color: packageTrendsPagePrimaryColor}}
                      className="flex items-center gap-1 text-orange-500">
                      <Star className="w-4 h-4 fill-current" />
                      <span className="text-xs font-bold">{itinerary?.rating || "N/A"}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {
            (Array.isArray(highlightedItineraries) && highlightedItineraries?.length < 1 ) && <div style={{padding: 20, backgroundColor: "rgba(255,0,0,0.1)", color: "red", textAlign: "center"}}>
              There are no itineraries at this moment...
            </div>
          }
        </section>

        {/* Why Choose Us */}
        <section style={{/*display: "none"*/}} className={`bg-gray-50 pb-24 pt-${highlightedItineraries?.[0] ? "24" : "4"}`}>
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center max-w-3xl mx-auto mb-16">
              <h2 style={{color: packageTrendsPageThirdColor}}
                className="text-4xl font-bold text-gray-900 -font-serif mb-6">Why We're Different</h2>
              <p style={{color: (packageTrendsPageThirdColor+"80")}}
                className="text-gray-500">
                We don't just organize trips; we create memories that last a lifetime through our deep local connections and commitment to excellence.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
              {[
                {
                  title: "Local Expertise",
                  desc: "Our team consists of passionate locals who know every hidden gem and secret spot in Ghana.",
                  icon: <Globe className="w-8 h-8 -text-orange-500" />
                },
                {
                  title: "Tailored Experiences",
                  desc: "Every itinerary is carefully curated to balance iconic landmarks with authentic cultural immersion.",
                  icon: <Star className="w-8 h-8 -text-orange-500" />
                },
                {
                  title: "Seamless Logistics",
                  desc: "From airport transfers to luxury stays, we handle every detail so you can focus on the journey.",
                  icon: <Calendar className="w-8 h-8 -text-orange-500" />
                }
              ].map((feature, i) => (
                <div key={i} className="bg-white p-10 -rounded-3xl shadow-sm border border-gray-100 text-center">
                  <div style={{backgroundColor: (packageTrendsPagePrimaryColor+"33"), color: packageTrendsPagePrimaryColor}}
                    className="w-16 h-16 bg-orange-50 -rounded-2xl flex items-center justify-center mx-auto mb-6">
                    {feature.icon}
                  </div>
                  <h4 style={{color: packageTrendsPageThirdColor}}
                    className="text-xl font-bold text-gray-900 mb-4 -font-serif">{feature.title}</h4>
                  <p style={{color: (packageTrendsPageThirdColor+"80")}} 
                    className="text-gray-500 text-sm leading-relaxed">{feature.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    );
}

export default Type5TrendsHomePage;